import {
  SpaceBetween,
  Container,
  Header,
  Box,
  FormField,
  ColumnLayout,
  Select,
  Input,
  Textarea,
} from "@cloudscape-design/components-themed";
import {
  APPROVAL_AFTER,
  LABELS,
  COMMENT_MAX_LENGTH,
  EXAMINATION_RESULT_SELECT,
  REQUEST_AFTER_FOR_APPROVER_ADMIN,
} from "./constants";
import { Dispatch, SetStateAction, useState } from "react";
import { DivisionDict } from "../default-constants";
import { getDisplayExaminationResult } from "./util";
import { getMessage } from "../../features/error/messages";
import { isLengthValid } from "../../utils/inputValidation";

interface IExaminationResultApproval {
  currentStage: number;
  selectedExaminationResult: DivisionDict;
  setSelectedExaminationResult: Dispatch<SetStateAction<DivisionDict>>;
  examinationResult: string;
  actionBy: string;
  actionAt: string;
  loginUser: string;
  approvalComment: string;
  setApprovalComment: Dispatch<SetStateAction<string>>;
}

/**
 * 審査結果承認
 */
const ExaminationResultApproval = (props: IExaminationResultApproval) => {
  const {
    currentStage,
    selectedExaminationResult,
    setSelectedExaminationResult,
    examinationResult,
    actionBy,
    actionAt,
    loginUser,
    approvalComment,
    setApprovalComment,
  } = props;
  const date = new Date();
  const today = `${date.getFullYear()}/${
    date.getMonth() + 1
  }/${date.getDate()}`;
  const isPossibleEdit = currentStage === REQUEST_AFTER_FOR_APPROVER_ADMIN;
  const displayExaminationResultApproval = [
    REQUEST_AFTER_FOR_APPROVER_ADMIN,
    APPROVAL_AFTER,
  ].includes(currentStage);
  const [actionCommentErrorMsg, setActionCommentErrorMsg] = useState("");

  /**
   * 承認または差戻コメントの入力ハンドラ.
   * @param {string} inputComment
   */
  const actionCommentOnChange = (inputComment: string) => {
    setApprovalComment(inputComment);
    const errorMsg = isLengthValid(inputComment, COMMENT_MAX_LENGTH)
      ? ""
      : getMessage("KGRERR058", 500).label;
    setActionCommentErrorMsg(errorMsg);
  };

  return (
    <>
      {displayExaminationResultApproval && (
        <SpaceBetween direction={"vertical"} size={"l"}>
          <Container
            header={
              <Header variant={"h2"}>
                {LABELS.EXAMINATION_RESULT_APPROVAL}
              </Header>
            }
          >
            <Box margin={"s"}>
              <SpaceBetween direction={"vertical"} size={"xs"}>
                <FormField label={LABELS.EXAMINATION_RESULT}>
                  <ColumnLayout columns={4}>
                    {isPossibleEdit ? (
                      <Select
                        selectedOption={selectedExaminationResult}
                        options={EXAMINATION_RESULT_SELECT}
                        filteringType={"none"}
                        onChange={({ detail }) =>
                          setSelectedExaminationResult(
                            detail.selectedOption as {
                              value: string;
                              label: string;
                            }
                          )
                        }
                      />
                    ) : (
                      <Input
                        value={getDisplayExaminationResult(examinationResult)}
                        readOnly
                      />
                    )}
                  </ColumnLayout>
                </FormField>
                <FormField label={LABELS.APPROVAL_DATE}>
                  <ColumnLayout columns={4}>
                    <Input
                      value={currentStage === APPROVAL_AFTER ? actionAt : today}
                      readOnly
                    />
                  </ColumnLayout>
                </FormField>
                <FormField label={LABELS.APPROVER}>
                  <Input
                    value={
                      currentStage === APPROVAL_AFTER ? actionBy : loginUser
                    }
                    readOnly
                  />
                </FormField>
                <FormField
                  label={
                    isPossibleEdit
                      ? LABELS.APPROVAL_OR_SEND_BACK_COMMENT
                      : LABELS.APPROVAL_REASON
                  }
                  constraintText={
                    isPossibleEdit ? `${COMMENT_MAX_LENGTH}文字以内` : ""
                  }
                  errorText={actionCommentErrorMsg}
                >
                  <Textarea
                    value={approvalComment}
                    onChange={({ detail }) =>
                      actionCommentOnChange(detail.value)
                    }
                    rows={2}
                    readOnly={currentStage === APPROVAL_AFTER}
                  />
                </FormField>
              </SpaceBetween>
            </Box>
          </Container>
        </SpaceBetween>
      )}
    </>
  );
};

export default ExaminationResultApproval;
